module.exports = __webpack_public_path__ + "static/media/White.95ad848f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/White.wav
// module id = 54
// module chunks = 0